module.exports = __webpack_public_path__ + "07b604674cd6198d263f60cf7daf0312.png";